import moment from "moment";
import "moment/locale/he";
import type { TFunction } from "i18next";
import type { ListingActivityItem } from "utils/listings/listingActivity";

/**
 * "היום 10:00", "מחר", "יום חמישי 18:30", "6 בנובמבר": when an activity item is, as a realtor reads
 * it. A whole-day item never shows a time.
 */
export function formatActivityWhen(item: Pick<ListingActivityItem, "at" | "allDay">, now: Date, t: TFunction, lng: string): string {
  const locale = lng?.startsWith("en") ? "en" : "he";
  const at = moment(item.at).locale(locale);
  const days = at.clone().startOf("day").diff(moment(now).startOf("day"), "days");
  const day =
    days === 0
      ? t("listingActivity.today")
      : days === 1
      ? t("listingActivity.tomorrow")
      : days === -1
      ? t("listingActivity.yesterday")
      : days > 1 && days < 7
      ? at.format("dddd")
      : at.format(locale === "he" ? "D [ב]MMMM" : "MMM D");
  return item.allDay ? day : `${day} ${at.format("HH:mm")}`;
}

/** "על ידך", a teammate's name, or their email when the office list does not know them. */
export function activityWho(item: Pick<ListingActivityItem, "isMine" | "byEmail">, names: ReadonlyMap<string, string>, t: TFunction): string {
  if (item.isMine) return t("listingActivity.byMe");
  return (item.byEmail && names.get(item.byEmail)) || item.byEmail || "—";
}

/** The item's line: its title, or what it is when it has none (an untitled task, a voice note). */
export function activityText(item: Pick<ListingActivityItem, "kind" | "text">, t: TFunction): string {
  return item.text || t(`listingActivity.kind.${item.kind}`);
}
